<div class="pm-container" *ngIf="SmuPmuData!=null">
    <div class="header">
        <h3>Close PM Service</h3>
        <button class="close-btn" (click)="Closepopup()">X</button>
    </div>

    <!-- Next PM -->
    <div class="pm-section">
        <label class="title">Next PM</label>

        <div class="row">
            <label>Date:</label>
            <label>{{SmuPmuData.NextPmDate |date: 'dd MMM yyyy'}}</label>
        </div>

        <div class="row">
            <label>PM Type:</label>
            <label>{{SmuPmuData.PmServiceNextPmDateS}}</label>
        </div>

        <div class="completed-row">
            <span>Completed</span>
             <mat-checkbox class="example-margin" [(ngModel)]="pm1Check"></mat-checkbox>
        </div>
    </div>
</div>


<div style="text-align: right;">
            <button mat-raised-button (click)="Closepopup()"> Cancel </button>
            <button mat-raised-button color="warn" (click)="Save()">
                Save
            </button>
        </div>